import styles from "./DisableBack.module.css";

export const DisableBack = () => (
    <div id="disableBack" className={styles.element}></div>
);
